import { FunctionComponent } from "react";
import { graphql } from "@apollo/client/react/hoc";

import {
    QUESTIONS_QUERY,
    CREATE_QUESTION_MUTATION,
    UPDATE_QUESTION,
    DELETE_QUESTION_MUTATION,
} from "../graphql";
import { captureException } from "@sentry/react";

// Query
export const withQuestions = (Component: FunctionComponent) =>
    graphql(QUESTIONS_QUERY, {
        options: ({ where, pagination }) => {
            return {
                variables: {
                    where,
                    ...pagination,
                },
            };
        },
        props: ({ data }) => {
            const {
                loading,
                error,
                questions,
                fetchMore,
                subscribeToMore,
                updateQuery,
                refetch,
            } = data;
            const loadQuestionsData = (offset: number) => {
                return fetchMore({
                    variables: {
                        offset,
                    },
                    updateQuery: (previousResult, { fetchMoreResult }) => {
                        return {
                            questions: [
                                ...previousResult.questions,
                                ...fetchMoreResult.questions,
                            ],
                        };
                    },
                });
            };
            if (error) throw new Error(error.message);
            return {
                loading,
                questions,
                subscribeToMore,
                updateQuery,
                loadQuestionsData,
                refetchQuestions: refetch,
            };
        },
    })(Component);

// Mutation
export const withCreateQuestion = (Component: FunctionComponent) =>
    graphql(CREATE_QUESTION_MUTATION, {
        props: ({ mutate }) => ({
            createQuestion: async (object: Object) => {
                // console.log(
                //     "🚀 ~ file: Operations.ts ~ line 60 ~ createQuestion: ~ object",
                //     object,
                // );
                try {
                    const {
                        data: { insert_question_one },
                    } = await mutate({
                        variables: { object },
                        optimisticResponse: {
                            __typename: "Mutation",
                            createQuestion: {
                                object,
                                __typename: "INSERT_QUESTION_ONE",
                            },
                        },
                    });
                    return insert_question_one;
                } catch (e) {
                    captureException(e)
                    console.error(e);
                }
            },
        }),
    })(Component);

export const withUpdateQuestion = (Component: FunctionComponent) =>
    graphql(UPDATE_QUESTION, {
        props: ({ mutate }) => ({
            updateQuestion: (object: Object) => {
                mutate({
                    variables: { ...object },
                    optimisticResponse: {
                        updateQuestion: {
                            ...object,
                            __typename: "question",
                        },
                    },
                });
            },
        }),
    })(Component);

export const withDeleteQuestion = (Component: FunctionComponent) =>
    graphql(DELETE_QUESTION_MUTATION, {
        props: ({ mutate }) => ({
            deleteQuestion: (id: string) => {
                mutate({
                    variables: { id },
                    optimisticResponse: {
                        __typename: "Mutation",
                        deleteQuestion: {
                            id,
                            __typename: "DELETE_QUESTION_BY_PK",
                        },
                    },
                });
            },
        }),
    })(Component);
